// Models
import { AssetViewModel } from '../../string/models/string-view.model';
import { BopUpdateModel } from '../services/bop.service';

export namespace BopActions {
	export class GetAll {
		static readonly type = '[Bop] Get Bops';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}

	export class SetAll {
		static readonly type = '[Bop] Set Bops';
		constructor(public bops: AssetViewModel[]) {}
	}

	export class Update {
		static readonly type = '[Bop] Update Bop';
		constructor(public data: { bop: BopUpdateModel; showSpinner?: boolean; showToast?: boolean } = { bop: null, showSpinner: false, showToast: false }) {}
	}

	export class UpdateSuccess {
		static readonly type = '[Bop] Update Bop Success';
		constructor(public bop: AssetViewModel) {}
	}

	export class UpdateError {
		static readonly type = '[Bop] Update Bop Error';
	}
}
